export const msalConfig = {
  auth: {
    clientId: "5e82f168-4480-41d5-b708-605fb460801c",
    authority: "https://login.microsoftonline.com/a2f8d3f4-1544-492f-8115-6fcc332e5505/",
    redirectUri: "/",
    postLogoutRedirectUri: "/login",
  }
};
